import { NgModule } from "@angular/core";
import { PaymentsModule } from "src/app/shared/shared/payments.module";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { EGiftCheckoutComponent } from "./e-gift/e-gift-checkout/e-gift-checkout.component";
import { EGiftDesignComponent } from "./e-gift/e-gift-design/e-gift-design.component";
import { EGiftDetailComponent } from "./e-gift/e-gift-detail/e-gift-detail.component";
import { EGiftValueSelectComponent } from "./e-gift/e-gift-value-select/e-gift-value-select.component";
import { EGiftComponent } from "./e-gift/e-gift.component";
import { GiftActivateComponent } from "./gift-activate/gift-activate.component";
import { GiftBalanceCheckComponent } from "./gift-balance-check/gift-balance-check.component";
import { GiftRoutingModule } from "./gift-routing.module";
import { GiftWalletCreatePassComponent } from "./gift-wallet-create-pass/gift-wallet-create-pass.component";

@NgModule({
	declarations: [
		EGiftComponent,
		EGiftDesignComponent,
		EGiftDetailComponent,
		EGiftCheckoutComponent,
		EGiftValueSelectComponent,
		GiftActivateComponent,
		GiftBalanceCheckComponent,
		GiftWalletCreatePassComponent,
	],
	imports: [SharedModule, GiftRoutingModule, PaymentsModule],
})
export class GiftModule {}
